import React from 'react';
import Icon from '../../../components/AppIcon';

const CoreLaunchFeatures = () => {
  const features = [
    { icon: 'UserCheck', text: 'Assign chores to specific children', color: '#2dd4bf' },
    { icon: 'Clock', text: 'Set deadlines and expected completion times', color: '#f59e0b' },
    { icon: 'BarChart2', text: 'Let children track chores in progress', color: '#a78bfa' },
    { icon: 'Camera', text: 'Submit proof of completion', color: '#2dd4bf' },
    { icon: 'CheckCircle', text: 'Parents approve or reject finished chores', color: '#f59e0b' },
    { icon: 'Layers', text: 'Accountability organized in one easy system', color: '#a78bfa' },
  ];

  return (
    <section className="py-24 relative overflow-hidden" style={{background: '#f8f7f4'}}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-widest" style={{background: '#2dd4bf15', color: '#0d9488', border: '1px solid #2dd4bf40'}}>
            <span className="w-2 h-2 rounded-full animate-pulse" style={{background: '#2dd4bf'}}></span>
            Available at Launch
          </div>
          <h2 className="font-heading font-bold leading-tight mb-5" style={{fontSize: 'clamp(2rem, 4vw, 3rem)', color: '#0f1f3d'}}>
            Core Launch Features
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{color: '#64748b'}}>
            At launch, Cynizee is focused on chore accountability — giving parents a real way to manage responsibilities without constantly reminding, checking, and repeating themselves.
          </p>
        </div>

        {/* SIGNATURE FEATURE — Full width hero card */}
        <div className="rounded-3xl p-8 sm:p-12 mb-6 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #0f1f3d 0%, #1a3a5c 50%, #0d2d4a 100%)'}}>
          {/* Background glow */}
          <div className="absolute top-0 right-0 w-80 h-80 rounded-full opacity-20 blur-3xl" style={{background: 'radial-gradient(circle, #ff6b6b, transparent)'}}></div>
          <div className="absolute bottom-0 left-0 w-60 h-60 rounded-full opacity-15 blur-3xl" style={{background: 'radial-gradient(circle, #2dd4bf, transparent)'}}></div>
          
          <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center gap-8">
            {/* Lock icon */}
            <div className="flex-shrink-0">
              <div className="w-20 h-20 rounded-2xl flex items-center justify-center shadow-2xl" style={{background: 'linear-gradient(135deg, #ff6b6b, #ff4444)'}}>
                <Icon name="Lock" size={36} className="text-white" />
              </div>
            </div>
            
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 mb-3 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" style={{background: 'rgba(255,107,107,0.2)', color: '#ff8a8a', border: '1px solid rgba(255,107,107,0.3)'}}>
                ⭐ Signature Feature
              </div>
              <h3 className="font-heading font-bold text-white mb-3" style={{fontSize: 'clamp(1.4rem, 3vw, 2rem)'}}>
                Favorite Apps Lock Until Chores Are Done
              </h3>
              <p className="text-lg leading-relaxed" style={{color: 'rgba(255,255,255,0.7)'}}>
                When a chore deadline passes without completion, the child's selected favorite apps are locked — creating real accountability without constant nagging. Parents stay in control.
              </p>
            </div>

            {/* Visual indicator */}
            <div className="flex-shrink-0 hidden lg:flex flex-col items-center gap-3">
              <div className="rounded-2xl p-4 text-center" style={{background: 'rgba(255,107,107,0.15)', border: '1px solid rgba(255,107,107,0.3)'}}>
                <Icon name="Smartphone" size={32} style={{color: '#ff6b6b'}} className="mx-auto mb-2" />
                <p className="text-xs font-bold" style={{color: '#ff8a8a'}}>Apps Locked</p>
              </div>
              <Icon name="ArrowDown" size={16} style={{color: 'rgba(255,255,255,0.3)'}} />
              <div className="rounded-2xl p-4 text-center" style={{background: 'rgba(45,212,191,0.15)', border: '1px solid rgba(45,212,191,0.3)'}}>
                <Icon name="Unlock" size={32} style={{color: '#2dd4bf'}} className="mx-auto mb-2" />
                <p className="text-xs font-bold" style={{color: '#2dd4bf'}}>Chore Done!</p>
              </div>
            </div>
          </div>
        </div>

        {/* Remaining features grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {features?.map((feature, i) => (
            <div
              key={i}
              className="rounded-2xl p-6 flex items-start gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg cursor-default"
              style={{background: '#fff', border: '1px solid #e2e8f0'}}
            >
              <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{background: `${feature?.color}18`}}>
                <Icon name={feature?.icon} size={20} style={{color: feature?.color}} />
              </div>
              <p className="font-medium text-sm leading-snug pt-1" style={{color: '#0f1f3d'}}>{feature?.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreLaunchFeatures;
